<template>
    <div>
        <address-section data-full-story/>
    </div>
</template>

<script>
// @ is an alias to /src
import AddressSection from '@/components/AddressSection';

export default {
    name: 'addressView',
    components: {
        AddressSection
    }
};
</script>
